<script setup>
const props = defineProps({
  title: {
    type: String,
    default: undefined,
  },

  pages: {
    type: Array,
    default: () => [],
  },

  countrySlug: {
    type: String,
    default: undefined,
  },
  pageType: {
    type: String,
    default: undefined,
  },
});
const emit = defineEmits(['redirect']);

const localePath = useLocalePath();

const showAllLink = computed(() =>
  localePath(`/trains/${props.countrySlug}/${props.pageType}/1`),
);
</script>

<template>
  <div class="grids-train-pages">
    <div class="grids-train-pages__title">
      <span class="grids-train-pages__font">
        {{ title }}
      </span>
    </div>

    <div class="grids-train-pages__pages">
      <CardsTrainPage
        v-for="(page, index) in pages"
        :key="index + page.title"
        :title="page.title"
        :url="page.href"
        :image-src="
          page.referenceImage?.original ||
          '/images/seo/default/featured-large.png'
        "
        @click="emit('redirect', page.href)"
      />
      <CardsTrainAll
        :page-type="pageType"
        :url="showAllLink"
        @click="emit('redirect', showAllLink)"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.grids-train-pages {
  display: flex;
  flex-direction: column;

  &__font {
    font-size: em(24);
    font-weight: 600;
    line-height: math.div(60, 24);
  }

  &__title {
    padding-left: em(12);
  }

  &__pages {
    display: grid;
    flex-grow: 1;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: em(187);
    gap: em(10);
  }
}
</style>
